module.exports = __webpack_public_path__ + "static/media/recarga_saldo_2.97c23969.svg";